import { KeenSliderInstance } from "keen-slider";

export function getSliderMaxIdx(slider: KeenSliderInstance): number {
    if (slider.options.loop) {
        // if (slider.track.details.slides[0].abs == 0) {
        //     return Math.max(...slider.track.details.slides.map((slide) => slide.abs));
        // } else {
        //     return (
        //         slider.track.details.slides.length -
        //         slider.track.details.slides.filter((slide) => slide.distance >= 0 && slide.distance < 1).length
        //     );
        // }
        return slider.slides.length - 1;
    }

    return slider.track.details.maxIdx;
}
